enum AdobeEventPageType {
  Home = 'home',
  Other = 'other',
  Service = 'service',
  VehicleDetails = 'vehicle-details',
  VehicleListing = 'vehicle-listing'
}

export default AdobeEventPageType;
